import { Dictionary } from '../dictionary.types'

const it: Dictionary = {
  'Together with': 'Insieme a',
}

export default it
